import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/accidentTransfer/transferApply/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/accidentTransfer/transferApply',
    exact: true,
    meta: {
      title: '转单申请'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/accidentTransfer/carRescue/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/accidentTransfer/carRescue',
    meta: {
      title: '车辆救援'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/accidentTransfer/transferFail/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/accidentTransfer/transferFail',
    meta: {
      title: '转单申请'
    }
  }
]
